// extracted by mini-css-extract-plugin
export default {"root":"Table_root__GSsVf","infos":"Table_infos__IL4eH","tooltip":"Table_tooltip__zu9Vi"};